<template>
    <div class="card-upload" v-bind="$attrs">
        <div class="card-upload-inner">
            <div v-if="label" class="txt-size"><span>{{label}}</span></div>
            <div class="fix-height">
                <img :src="imagePlaceholder"
                     v-if="imagePlaceholder && !imagePreview"
                     height="200"/>
                <img :src="imagePreview"
                     v-if="imagePreview"
                     alt=""
                     />
            </div>

            <label :for="inputId" class="btn-upload-icon">
                <i class="fas fa-upload"></i>
            </label>

            <v-btn icon small @click="clear" v-if="imagePreview" class="btn-delete">
                <i class="fal fa-times"></i>
            </v-btn>

            <input
                    ref="file"
                    type="file"
                    class="input_hidden"
                    :id="inputId"
                    @change="onChange()"
                    accept="image/png, image/jpeg"
                    :disabled="disabled"
            />
        </div>
    </div>
</template>

<script>
  import ImageReaderUtil from '../../utils/image-reader.util';

  export default {
    name: "ImagePickerInput",
    props: {
      value: {},
      label: String,
      imagePlaceholder: String,
      disabled: { type: Boolean, default: false},
    },
    data: () => ({
      imagePreview: null,
    }),
    computed: {
      inputId() {
        return `uploader-${this._uid}`;
      },
    },
    methods: {
      clear() {
        this.$refs.file.value = '';
        this.$emit('input', null);
      },
      onChange() {
        this.$emit('input', this.$refs.file.files[0]);
      },
    },
    watch: {
      value: {
        async handler(value) {
          if (!value) {
            return this.imagePreview = null;
          }

          try {
            this.imagePreview = await ImageReaderUtil.readAsDataURL(value);
          } catch (e) {
            this.imagePreview = null;
          }
        }
      },
    }
  }
</script>

<style scoped>

</style>
